export const activeCountStyles = theme => ({
  color: theme.palette.primary.dark,
  cursor: 'default',
  fontSize: 13,
});

export const borderStyles = theme => ({
  border: `1px solid ${theme.palette.graphic.light}`,
});

export const chevronRightStyles = theme => ({
  color: theme.palette.secondary.main,
  justifySelf: 'end',
  size: 24,
});

export const chipStylesStyles = theme => ({
  ...theme.palette.text.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.light,
  borderRadius: 2,
  color: theme.palette.text.primary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  marginRight: theme.spacing(1),
  transition: [
    ['background', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
    ['box-shadow', '300ms', 'cubic-bezier(0.4, 0, 0.2, 1)', '0ms'],
  ],
  width: 23,
});

export const chipStylesSelectedStyles = theme => ({
  ...theme.palette.text.caption,
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 2,
  color: theme.palette.text.primary,
  display: 'flex',
  fontWeight: 400,
  height: 20,
  justifyContent: 'center',
  marginRight: theme.spacing(1),
  width: 23,
});

export const flexRowStyles = {
  alignItems: 'center',
  display: 'flex',
};

export const inactiveCountStyles = theme => ({
  color: theme.palette.text.secondary,
  cursor: 'default',
  fontSize: 13,
  marginTop: 2,
});

export const labelStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.primary.dark,
});

export const linkStyles = theme => ({
  '&:hover': {
    '& $chipStyles': {
      backgroundColor: theme.palette.primary.light,
    },
    '& .MuiChip-root': { backgroundColor: theme.palette.primary.light },
    backgroundColor: theme.palette.secondary.light,
  },
  borderBottom: `1px solid ${theme.palette.surface.swimlane}`,
  display: 'grid',
  gridGap: theme.spacing(1),
  gridTemplateColumns: '100%',
  padding: theme.spacing(2),
  textDecoration: 'none',
  width: '100%',
});

export const listStyles = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

export const selectedListItemStyles = theme => ({
  '& .MuiChip-root': { backgroundColor: theme.palette.primary.light },
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  backgroundColor: theme.palette.secondary.light,
});

export const titleStyles = theme => ({
  ...theme.typography.subtitle1,
  color: theme.palette.text.primary,
  flex: theme.spacing(0, 0, 30),
  fontWeight: 300,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('lg')]: {
    flex: 'none',
  },
});
